import * as R from 'ramda';
import sportsApi from '../../utils/sportsApi';

const fetchScheduledReports = store => async state => {
    const userClientId = state.user.selectedUserClientId;
    const clientId = state.user.selectedClientId;

    const schedules =
        (await sportsApi
            .url(`/mvc-schedules?type=mvc_reports`)
            .query({
                clientId,
            })
            .get()
            .json()) || [];

    store.setState(
        R.assocPath(
            ['clients', userClientId, 'scheduledReports'],
            schedules,
            store.getState(),
        ),
        true,
    );
};

export default fetchScheduledReports;
